import React from 'react'

const ButtonMain = ({ background, text, onClick }) => {
  return (
    <button onClick={onClick} className={`btn-main ${background}`}>
      {text}
    </button>
  )
}

export default ButtonMain
